"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomSelectRenderExample = void 0;
var tslib_1 = require("tslib");
var mithril_1 = tslib_1.__importDefault(require("mithril"));
var examples_1 = require("@shared/examples");
var _1 = require("@/");
var EXAMPLE_SRC = 'components/custom-select/examples/itemRender.ts';
var options = [
    {
        label: 'First',
        value: '1'
    },
    {
        label: 'Second',
        value: '2',
        disabled: true
    },
    {
        label: 'Third',
        value: '3'
    },
    {
        label: 'Fourth',
        value: '4'
    }
];
var CustomSelectRenderExample = /** @class */ (function () {
    function CustomSelectRenderExample() {
    }
    CustomSelectRenderExample.prototype.view = function () {
        return (0, mithril_1.default)(examples_1.Example, { src: EXAMPLE_SRC }, [
            (0, mithril_1.default)(_1.CustomSelect, {
                triggerAttrs: {
                    align: 'left',
                    style: 'width: 300px'
                },
                defaultValue: '3',
                itemRender: function (item, isSelected, index) { return (0, mithril_1.default)(_1.ListItem, {
                    contentLeft: (0, mithril_1.default)(_1.Icon, {
                        name: index % 2 ? _1.Icons.FILE_PLUS : _1.Icons.USERS
                    }),
                    style: index % 2 ? 'color: red' : undefined,
                    label: item.label,
                    selected: isSelected
                }); },
                options: options
            })
        ]);
    };
    return CustomSelectRenderExample;
}());
exports.CustomSelectRenderExample = CustomSelectRenderExample;
